import { useState } from 'react'
import { router } from '@inertiajs/react'
import Logo from '../../components/Logo'

export default function Consent({ client_name, scope, oauth_params }) {
  const displayName = client_name || 'Unknown Client'
  const [submitting, setSubmitting] = useState(false)

  // CRITICAL-3/W-03: the consent decision travels as a CSRF-protected POST
  // to /oauth/authorize/consent — never as a GET query string. Mirrors the
  // same router.post pattern used by OAuth/SelectWorkspace.jsx.
  function handleApprove(e) {
    e.preventDefault()
    setSubmitting(true)
    router.post('/oauth/authorize/consent', { ...oauth_params, consent: 'granted' }, {
      onFinish: () => setSubmitting(false),
    })
  }

  return (
    <div className="min-h-screen bg-zinc-900 flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[500px] h-[500px] rounded-full bg-indigo-900/8 blur-3xl" />
      </div>

      <div className="w-full max-w-sm relative z-10">
        <div className="mb-10 flex justify-center">
          <div className="flex flex-col items-center gap-5">
            <Logo variant="mark" size={120} />
            <p className="text-sm font-mono font-bold tracking-[0.5em] uppercase text-emerald-300">anamnesis</p>
          </div>
        </div>

        <div className="bg-zinc-800/30 border border-zinc-600/50 rounded-2xl p-6">
          <div className="mb-5">
            <h2 className="text-xs font-mono font-bold text-zinc-300 mb-1 uppercase tracking-widest">
              Authorize access
            </h2>
            <p className="text-xs font-mono text-zinc-600">
              Review what this application is requesting before granting access.
            </p>
          </div>

          <div className="mb-5 space-y-3">
            <div className="px-4 py-3 rounded-lg border border-zinc-700 bg-zinc-800/40">
              <p className="text-[10px] font-mono text-zinc-500 uppercase tracking-wider mb-1">Application</p>
              <p className="text-sm font-mono text-zinc-100 truncate">{displayName}</p>
            </div>

            <div className="px-4 py-3 rounded-lg border border-zinc-700 bg-zinc-800/40">
              <p className="text-[10px] font-mono text-zinc-500 uppercase tracking-wider mb-1">Requested scope</p>
              <p className="text-sm font-mono text-zinc-100">{scope}</p>
            </div>
          </div>

          <form onSubmit={handleApprove} className="space-y-2">
            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-emerald-800/60 hover:bg-emerald-700/80 disabled:opacity-50 disabled:cursor-not-allowed text-emerald-200 border border-emerald-700/40 font-mono text-sm font-semibold py-2.5 px-4 rounded-lg transition-colors"
            >
              {submitting ? 'Approving...' : 'Approve'}
            </button>
          </form>
        </div>

        <p className="mt-6 text-center text-[10px] font-mono text-zinc-500 tracking-wider uppercase">
          persistent memory for AI agents
        </p>
      </div>
    </div>
  )
}
